import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { BUILDINGS, CONTACT } from "@/data/content";

export const Footer = () => {
  const { lang, t } = useLanguage();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-ink/5 bg-ink text-white"
    >
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <p className="font-serif text-3xl leading-tight md:text-4xl">
              Fafapiti <span className="italic text-turquoise">Lodge</span>
            </p>
            <p className="mt-4 text-sm text-white/50">{t.footer.tagline}</p>
            <p className="mt-8 inline-block border border-turquoise/40 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-turquoise">
              {t.footer.sale}
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
              {t.contact.title}
            </p>
            <a
              data-testid="footer-email"
              href={`mailto:${CONTACT.email}`}
              className="mt-4 block whitespace-nowrap text-xs text-white/80 transition-colors duration-300 hover:text-turquoise md:text-sm"
            >
              {CONTACT.email}
            </a>
          </div>
          <div className="md:col-span-4">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
              {t.chapters.two.title}
            </p>
            <div className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2">
              {BUILDINGS.map((b) => (
                <Link
                  key={b.slug}
                  data-testid={`footer-link-${b.slug}`}
                  to={`/batiment/${b.slug}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-turquoise"
                >
                  {b.name[lang]}
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-2 border-t border-white/10 pt-6 text-[11px] uppercase tracking-[0.18em] text-white/30 md:flex-row md:items-center md:justify-between">
          <span>Fafapiti Lodge Fakarava — {new Date().getFullYear()}</span>
          <span>{t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
};
